<template>
  <div>
    <h3 class="mb-4">
      Wallets
    </h3>
    <v-sheet
      v-if="loading"
      :color="`grey lighten-4`"
      class="pa-3"
    >
      <v-skeleton-loader
        class="mx-auto d-flex flex-column align-content-space-between"
        min-height="404"
        type="paragraph, paragraph, paragraph, paragraph, paragraph, actions"
      />
    </v-sheet>
    <v-card
      v-else
      class="pa-2"
      color="#f2f2f2"
    >
      <v-row v-if="summaryData">
        <CardWalletsSummaryDetail
          v-for="(detail, name) in summaryData.summaries"
          :key="name"
          :data="detail"
          :name="name"
        />
      </v-row>
      <v-divider class="mt-4" />
      <v-card-actions
        v-if="summaryData"
        class="d-flex justify-space-between align-center"
      >
        <v-spacer />
        <v-btn
          color="primary"
          :loading="isDownloading"
          @click="openDialog('download')"
        >
          Download
        </v-btn>
        <v-btn
          color="primary"
          :loading="isStoreLoading"
          @click="openDialog('store')"
        >
          Store on Google Drive
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <v-card>
        <v-card-title>Enter Balances</v-card-title>
        <v-card-text>
          <v-alert
            type="info"
            dense
          >
            These inputs are optional, you can leave 1 or more empty.
          </v-alert>
          <v-text-field
            v-model="tempFirstAccountUkBalance"
            label="Remittance - Safeguarding Balance for UK (Safe 01)"
          />
          <v-text-field
            v-model="tempFirstAccountEuropeBalance"
            label="Wallet - Safeguarding Balance for EU (Safe 01)"
          />
          <v-text-field
            v-model="tempFirstAccountCaBalance"
            label="Wallet - Safeguarding Balance for Canada (Safe 01)"
          />
          <v-text-field
            v-model="tempSecondAccountUkBalance"
            label="Remittance - Safeguarding Balance for UK (Safe 02)"
          />
          <v-text-field
            v-model="tempSecondAccountEuropeBalance"
            label="Wallet - Safeguarding Balance for EU (Safe 02)"
          />
          <v-text-field
            v-model="tempSecondAccountCaBalance"
            label="Wallet - Safeguarding Balance for Canada (Safe 02)"
          />
          <v-text-field
            v-model="tempTotalBalance"
            label="Total Balance"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="submitValues"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SafeguardingService from "@/services/SafeguardingService";
import CardWalletsSummaryDetail from "./CardWalletsSummaryDetail";

export default {
  name: "CardWalletsSummary",
  components: {
    CardWalletsSummaryDetail,
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    summaryData: {
      type: Object,
      default: () => {
      }
    },
    license: {
      type: String,
      default: ""
    },
    firstAccountUkBalance: {
      type: String,
      default: null
    },
    firstAccountEuropeBalance: {
      type: String,
      default: null
    },
    firstAccountCaBalance: {
      type: String,
      default: null
    },
    secondAccountUkBalance: {
      type: String,
      default: null
    },
    secondAccountEuropeBalance: {
      type: String,
      default: null
    },
    secondAccountCaBalance: {
      type: String,
      default: null
    },
    totalBalance: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isDownloading: false,
      isStoreLoading: false,
      dialog: false,
      tempFirstAccountUkBalance: null,
      tempFirstAccountEuropeBalance: null,
      tempFirstAccountCaBalance: null,
      tempSecondAccountUkBalance: null,
      tempSecondAccountEuropeBalance: null,
      tempSecondAccountCaBalance: null,
      tempTotalBalance: null,
      actionType: "",
    };
  },
  methods: {
    async storeOnGoogleDrive() {
      this.$emit("page-loading", true);
      this.isStoreLoading = true;
      try {
        const resp = await SafeguardingService.storeSafeguardingReportFileOnDrive({
          license: this.license,
          firstAccountUkBalance: this.firstAccountUkBalance || null,
          firstAccountEuropeBalance: this.firstAccountEuropeBalance || null,
          firstAccountCaBalance: this.firstAccountCaBalance || null,
          secondAccountUkBalance: this.secondAccountUkBalance || null,
          secondAccountCaBalance: this.secondAccountCaBalance || null,
          totalBalance: this.totalBalance || null
        });
        console.log("File stored successfully. Response: ", resp.data);
      } catch (e) {
        console.error(e);
      } finally {
        this.$emit("page-loading", false);
        this.isStoreLoading = false;
      }
    },
    downloadFile() {
      this.$emit("page-loading", true);
      this.isDownloading = true;
      SafeguardingService.downloadSafeguardingReportFile({
        license: this.license,
        firstAccountUkBalance: this.firstAccountUkBalance || null,
        firstAccountEuropeBalance: this.firstAccountEuropeBalance || null,
        firstAccountCaBalance: this.firstAccountCaBalance || null,
        secondAccountUkBalance: this.secondAccountUkBalance || null,
        secondAccountEuropeBalance: this.secondAccountEuropeBalance || null,
        secondAccountCaBalance: this.secondAccountCaBalance || null,
        totalBalance: this.totalBalance || null
      })
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
            "download",
            `Daily_Cash_Reconciliation_Wallet_${new Date().toISOString()}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.isDownloading = false;
      })
      .finally(() => {
        this.$emit("page-loading", false);
        this.isDownloading = false;
      });
    },
    openDialog(actionType) {
      this.dialog = true;
      this.actionType = actionType;
    },
    submitValues() {
      this.dialog = false;
      this.firstAccountUkBalance = this.tempFirstAccountUkBalance || null;
      this.firstAccountEuropeBalance = this.tempFirstAccountEuropeBalance || null;
      this.firstAccountCaBalance = this.tempFirstAccountCaBalance || null;
      this.secondAccountUkBalance = this.tempSecondAccountUkBalance || null;
      this.secondAccountEuropeBalance = this.tempSecondAccountEuropeBalance || null;
      this.secondAccountCaBalance = this.tempSecondAccountCaBalance || null;
      this.totalBalance = this.tempTotalBalance || null;

      if (this.actionType === "download") {
        this.downloadFile();
      } else {
        this.storeOnGoogleDrive();
      }
    }
  }
};
</script>
